const angular = require('angular')
const netFolderService = require('./netFolderService')
const netFolderCtrl = require('./netFolderCtrl')
const nfListCtrl = require('./nfListCtrl')
const fileDetailCtrl = require('./fileDetailCtrl')
const selectFilesCtrl = require('./selectFilesCtrl')
const searchFileCtrl = require('./searchFileCtrl')
const autofocusDirective = require('./autofocusDirective')

module.exports = angular.module('hxphone.netFolder', ['hxphone.services'])
  .factory('netFolderService', netFolderService)
  .controller('netFolderCtrl', netFolderCtrl)
  .controller('nfListCtrl', nfListCtrl)
  .controller('fileDetailCtrl', fileDetailCtrl)
  .controller('selectFilesCtrl', selectFilesCtrl)
  .controller('searchFileCtrl', searchFileCtrl)
  .directive('autofocus', autofocusDirective)



// WEBPACK FOOTER //
// ./src/js/netFolder/module.js